import Mooring from './Mooring';
export default class MooringDepartureData extends Mooring {
}
//# sourceMappingURL=MooringDepartureData.js.map